var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length)?_c('div',{staticClass:"pt-0 py-md-10"},[_c('v-container',[_c('SectionTitle',{staticClass:"mb-4",attrs:{"title":"Categories"}}),_c('CategoryCardSlider',{attrs:{"items":_vm.tags}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }